<template>
    <div id="packer_layout">
        <div v-if="is_initialized">
            <div class="ui equal width grid">
                <div class="column">
                    <CommandPanel
                    :scanner_modes="scanner_modes"
                    :current_scanner_mode="current_scanner_mode"
                    />
                    <div class="ui divider"></div>
                    <CurrentPack
                    :current_pack="current_pack"
                    />
                </div>
                <div class="column">
                    <Workspace
                    :packs="packs"
                    :current_pack="current_pack"
                    :all_packs="packer_store.packs"
                    />
                </div>
            </div>
        </div>
        <div v-else class="ui active centered inline large loader"></div>
    </div>
</template>

<script>
import Workspace from "./components/unpack/workspace.vue"
import CommandPanel from "./components/unpack/command_panel.vue"
import CurrentPack from "./components/unpack/current_pack.vue"
export default {
    data: function() {
        return {
            is_initialized: false,
            errors: [],
        }
    },
    computed: {
        packer_store: function() {
            return this.$store.state.packer_module.unpack_mode;
        },
        scanner_modes: function() {
            return this.packer_store.scanner_modes;
        },
        current_scanner_mode: function() {
            return this.packer_store.current_scanner_mode;
        },
        packs: function() {
            return _.filter(this.packer_store.packs, {"packed_by_number": null});
        },
        current_pack: function() {
            return this.packer_store.current_pack;
        },
    },
    watch: {
        '$route' (to, from) {
            this.set_breadcrumbs();
        }
    },
    created: function() {
        
        this.init();
        this.set_breadcrumbs();
    },
    mounted: function() {
        
        var that = this;

        that.$bus.$off("packer_command_center");
        that.$bus.$on("packer_command_center", function(action, params) {
            console.log("packer_command_center:" + action + params);
            switch (action) {
                case "commands":
                    that.commands(params);
                    break;
                case "change_scanner_mode":
                    that.change_scanner_mode(params);
                    break;
                case "unpacking":
                    that.unpacking(params);
                    break;
                case "show":
                    that.show(params);
                    break;
                default:
            }
        }.bind(this));
    },
    methods: {
        init: function() {
            var that = this;
            const promise = new Promise(function(resolve, reject) {
                resolve();
            })

            promise.then(function() {
                that.is_initialized = false;
            }).then(function() {
                that.change_scanner_mode(that.scanner_modes[0]);
            }).then(function() {
                that.packer_store.workspace_identity = that.$store.state.stations[4].workspaces[0].identity;
            }).then(function() {
                return that.get_packs();
            }).then(function() {
                that.$noty.information("拆包界面初始化完畢");
                that.is_initialized = true;
            }).catch(function (error) {
                switch (error) {
                    default:

                }
            });
        },
        get_packs: function() {
            var that = this;
            var url = new RestUrl(that.$store.state.shipper_routes.api_v1_provider_workspace_workflows).parse(
                {
                    workspace_identity: that.packer_store.workspace_identity
                },
                '?authorization=' + that.$store.state.shipper.authorization
            )

            return axios.get(url)
                .then(function (response) {
                    that.packer_store.packs = _.map(response.data.workflows, function(workflow) {
                         return _.extend({}, workflow, {packed_by_number: null});
                    });
                    that.$noty.success('已抓取workflows.')
                })
                .catch(function (error) {
                    that.$noty.error('Failed to fetch workflows.')
                });
        },
        set_breadcrumbs: function() {
            var that = this;
            var packer = {
                route_name: "unpack",
                name: "拆包界面"
            }

            switch (that.$route.name) {
                case "unpack":
                    that.$store.state.breadcrumbs = [packer]
                    break;
            }
        },
        // CommandCenter
        commands: function(barcode) {
            var that = this;

            switch (barcode) {
                case "##show":
                    that.change_scanner_mode("show");
                    break;
                case "##unpacking":
                    that.change_scanner_mode("unpacking");
                    break;
                default:
                    switch (that.packer_store.scanner_mode) {
                        case "show":
                            that.show(barcode);
                            break;
                        case "unpacking":
                            that.unpacking(barcode);
                            break;
                        default:
                            that.$noty.error("尚未選擇模式");
                    }
            }
        },
        change_scanner_mode: function(mode) {
            var that = this;
            switch (mode) {
                case "up":
                    var current_index = _.indexOf(that.scanner_modes, that.packer_store.current_scanner_mode);
                    if (that.scanner_modes[current_index + 1]) {
                        that.packer_store.current_scanner_mode = that.scanner_modes[current_index + 1];
                    } else {
                        that.packer_store.current_scanner_mode = _.head(that.scanner_modes);
                    }
                    that.$noty.success("切換模式：" + that.$t('packer.' + that.packer_store.current_scanner_mode));
                    break;
                case "down":
                    var current_index = _.indexOf(that.scanner_modes, that.packer_store.current_scanner_mode);
                    if (that.scanner_modes[current_index - 1]) {
                        that.packer_store.current_scanner_mode = that.scanner_modes[current_index - 1];
                    } else {
                        that.packer_store.current_scanner_mode = _.last(that.scanner_modes);
                    }
                    that.$noty.success("切換模式：" + that.$t('packer.' + that.packer_store.current_scanner_mode));
                    break;
                default:
                    that.packer_store.current_scanner_mode = mode;
                    that.$noty.success("切換模式：" + that.$t('packer.' + mode));
            }
        },
        show: function(number) {
            var that = this;
            if (that.is_legal_input(number)) {
                var result = _.find(that.packer_store.packs, {'core_waybill_number': number});
                if (result) {
                    that.packer_store.current_pack = result;
                } else {
                    that.$noty.error("此號碼尚未進入工作區，請以點貨或加包模式加入後再繼續");
                }
            }
        },
        unpacking: function(number) {
            var that = this;
            if (that.is_legal_input(number)) {
                console.log(number + "拆包");
            }
        },
        is_legal_input: function(input) {
            var that = this;
            if (input) {
                if (input.replace(/\s/g, '').length) {
                    return true;
                } else {
                    that.$noty.error("無效的輸入");
                    return false;
                }
            } else {
                that.$noty.error("請輸入號碼");
                return false;
            }
        },
    },
    components: {
        Workspace,
        CommandPanel,
        CurrentPack,
    }
}
</script>
